import { Link } from 'react-router-dom';
import { AdminLayout } from '../components/admin-layout';
import { Card } from '../components/ui';

export function NotFoundPage() {
  return (
    <AdminLayout title="Halaman Tidak Ditemukan">
      <Card style={{ border: '1px solid #E2E8F0', boxShadow: 'none' }}>
        <p>Halaman yang Anda cari tidak tersedia.</p>
        <Link to="/dashboard" style={{ color: '#1D4ED8', fontWeight: 600 }}>
          Kembali ke Dashboard
        </Link>
      </Card>
    </AdminLayout>
  );
}
